export default function ClientsPage() {
  return <div>Clients Page</div>;
}